import React, { useMemo } from 'react';
import { useSignals } from '@preact/signals-react/runtime';
import { AiAgentChat } from '@/features/ai-agents/chat/ai-agent-chat';
import { useAiComponentContext } from '@/features/editor/widgets/shared/ai-editing-layout/context';
import { useLoggedInAccount } from '@/features/account-context';

export function AiComponentPrompt() {
  const aiSessionId = useAiComponentContext((ctx) => ctx.sessionId);
  const onPromptNewSession = useAiComponentContext((ctx) => ctx.onNewSessionId);
  const onPromptReply = useAiComponentContext((ctx) => ctx.onPromptReply);
  const onLoadingChanged = useAiComponentContext((ctx) => ctx.onLoadingChange);
  const onNewMessageSent = useAiComponentContext((ctx) => ctx.onNewMessageSent);
  const onSessionLoaded = useAiComponentContext((ctx) => ctx.onSessionLoaded);
  const sessionData = useAiComponentContext((ctx) => ctx.sessionData);
  const selectedAgent = useAiComponentContext((ctx) => ctx.selectedAgent);
  const starters = useAiComponentContext((ctx) => ctx.starters);
  const contextualAttachments = useAiComponentContext(
    (ctx) => ctx.contextualAttachments,
  );
  const alias = useMemo(() => useLoggedInAccount()?.store?.alias || ``, []);
  useSignals();

  const key = aiSessionId.value?.includes(`restored`) ? aiSessionId.value : ``;

  return (
    <AiAgentChat
      key={key}
      userIdOverride={alias}
      agentId={selectedAgent.value.id}
      agentType={selectedAgent.value.type}
      enableVoiceInput={false}
      enableExamples={false}
      sessionData={sessionData.value || {}}
      padding="0rem"
      initialSessionId={aiSessionId.value || ``}
      onLoadingChanged={onLoadingChanged}
      onNewMessageSent={onNewMessageSent}
      onNewSession={onPromptNewSession}
      onSessionLoaded={onSessionLoaded}
      onNewReply={onPromptReply}
      enableFilesUpload
      inputBottom="0.3rem"
      inputLeft="0"
      inputRight="0"
      starters={starters}
      contextualAttachments={contextualAttachments}
    />
  );
}
